export default "__VITE_ASSET__Dvo6RsJK__"